import React from 'react';
import Footer from 'app/components/Footer';
import { SoftwareSignals } from 'app/components/Landing/SoftwareSignals';
import OptimizedAnimationBox from 'app/components/Landing/OptimizedAnimationBox';
import { ReversedCard } from 'app/components/Landing/ReversedCard';
import { DataFormatsSection } from 'app/components/Landing/DataFormatsSection';
import { ResponsiveResearch } from 'app/components/Landing/ResponsiveResearch';
import AppBar from 'app/components/Layout/AppBar';
import { PricingPlansSection } from 'app/components/Landing/PricingPlansSection';
import { ParallaxBackground } from 'app/components/ParallaxBackground';
import { SmoothScroll, ScrollRevealSection } from 'app/components/SmoothScroll';

/**
 * The homepage.
 *
 * Order: what the catalogue is (hero, all figures derived from the registry),
 * then the catalogue itself, then how you use it, then price.
 *
 * Removed from this file: a seeded "daily API calls" generator that wrote
 * invented per-dataset traffic numbers into localStorage and rendered nowhere,
 * a duplicate hardcoded list of 25 dataset names that had already drifted from
 * the registry, and a commented-out "Institutional Partners" wall of 21 named
 * fund avatars we have no attestation for.
 */
function LandingPage() {
  return (
    <SmoothScroll>
      <div className="relative bg-transparent overflow-hidden">
        <ParallaxBackground particleCount={20} />
        <AppBar />

        {/*
          <main> wraps the page content below the header so assistive tech has
          a skip target. The catalogue pages already do this; the landing page
          was the last route without a main landmark.
        */}
        <main>
          <SoftwareSignals />

          {/* The catalogue, rendered from the registry. */}
          <OptimizedAnimationBox />

          <ScrollRevealSection threshold={0.2} delay={100}>
            <ReversedCard />
          </ScrollRevealSection>

          <ScrollRevealSection threshold={0.2} delay={100}>
            <DataFormatsSection />
          </ScrollRevealSection>

          <ScrollRevealSection threshold={0.2} delay={100}>
            <ResponsiveResearch />
          </ScrollRevealSection>

          {/* Provenance moved to /about — the front page stays a catalogue. */}

          <ScrollRevealSection threshold={0.2} delay={100}>
            <PricingPlansSection />
          </ScrollRevealSection>
        </main>

        <Footer />
      </div>
    </SmoothScroll>
  );
}

export default LandingPage;
